// `video.edit`: live's Video Edit tool (#209): a video remade from a source video.
// Live stores an edit as EDIT_VIDEO, which its label map lacks, so its list shows no word.
// The body: the source video, the references and elements where the block takes them,
// and the ratio, length and resolution only where the model offers them (the composer
// leaves the others null). An Actions tool's form, not a frame, makes it: its own pair.
import { VideoEditQuote, VideoEditRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { assetRefOf, elementsOf } from "./shared";

export const jobType: JobTypeModule<"video.edit"> = {
  type: "video.edit",
  label: "",
  source: "tool",
  pair: "video.edit",
  fields: (draft, advanced) => ({
    type: draft.type,
    model: draft.model,
    outputs: draft.outputs,
    ...(draft.aspectRatio === null ? {} : { aspect_ratio: draft.aspectRatio }),
    ...(draft.durationSeconds === null ? {} : { duration_seconds: draft.durationSeconds }),
    ...(draft.resolution === null ? {} : { resolution: draft.resolution }),
    ...(draft.sourceVideo === null ? {} : { source_video: draft.sourceVideo }),
    ...(draft.references.length === 0 ? {} : { reference_images: draft.references }),
    // Beyond live, where the block takes them (Kling 4.0 Edit, G2-kling-v4-edit-inputs).
    ...(draft.videos.length === 0
      ? {}
      : { reference_videos: draft.videos.map((video) => assetRefOf(video)) }),
    ...elementsOf(draft),
    keep_source_audio: draft.keepSourceAudio,
    ...(advanced === null ? {} : { advanced }),
  }),
  request: VideoEditRequest,
  quote: VideoEditQuote,
};
